module.exports = __webpack_public_path__ + "img/SKO.37d4c2de.png";